<kendo-textbox #filterBox
               [clearButton]="true"
               [placeholder]="placeholder"
               [maxlength]="50"
               [value]="filterValue"
               (inputBlur)="onFilterInputBlur()"
               (inputFocus)="onFilterInputFocus()"
               (valueChange)="onFilterTextChange($event)">
  <ng-template kendoTextBoxPrefixTemplate
               *ngIf="showSearchButton">
    <button kendoButton
            class="searchButton"
            (click)="onButtonClick()"
            [svgIcon]="searchSvg"></button>
  </ng-template>
</kendo-textbox>
